export default {
  state:{
    name:"",
    email:"",
    loggedin:0,
  },
  getters:{
    getName:(state)=>{
      return state.name;
    },
    getMail:(state)=>{
      return state.email;
    },
    cardLogged:(state)=> {
      return state.loggedin
    }
  
  },
  mutations:{
    setName:(state,name)=>{
      state.name=name;
    },
    setMail:(state,email)=>{
      state.email = email;
    },
    cardLogged:(state,loggedin)=> {
      state.loggedin = loggedin;
    }
  
  }
}
